import { egresadosApiCall } from "../../../../axios/apiClient";

const controller = `habilidades`;

export default {
    getHabilidadesMe: async () => {
        let response = { success: true };
        const method = `me`;
        try {
            const apiResponse = await egresadosApiCall.get(controller, method);
            response.data = apiResponse?.data;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    },
    createHabilidad: async (data) => {
        let response = { success: true };
        const method = `me`;
        try {
            const apiResponse = await egresadosApiCall.post(controller, method, data);
            response.data = apiResponse?.data;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    },
    editHabilidad: async (data) => {
        let response = { success: true };
        const method = `me`;
        try {
            const apiResponse = await egresadosApiCall.put(controller, method, data);
            response.data = apiResponse?.data;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    },
    deleteHabilidad: async (id) => {
        let response = { success: true };
        const method = `me/${id}`;
        try {
            const apiResponse = await egresadosApiCall.delete(controller, method);
            response.data = apiResponse?.data;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    },
}